import Reveal from "@/components/Reveal";

const ANCHORS = [
  {
    figure: "$1T+",
    caption: "Projected value creation in the autonomous industrial layer.",
    source: "Category estimate · Internal thesis",
  },
  {
    figure: "80%+",
    caption:
      "U.S. reliance on foreign APIs and finished dose across multiple critical therapeutic categories.",
    source: "Public record · Policy briefings",
  },
  {
    figure: "24 / 7",
    caption:
      "Continuous run-state of a fully autonomous pharmaceutical facility.",
    source: "Dark Factory reference architecture",
  },
  {
    figure: "0",
    caption:
      "Hallucinations tolerated in a physics-bounded, in-spec / out-of-spec control regime.",
    source: "Giga One operating principle",
  },
];

export default function NumericAnchors() {
  return (
    <section
      id="signals"
      data-testid="signals-section"
      className="border-b border-[color:var(--g1-rule)]"
    >
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 lg:px-14 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-3 lg:col-span-2">
            <Reveal>
              <div className="g1-label">SEC. 07</div>
              <div className="g1-eyebrow mt-2">Signals</div>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-9 lg:col-span-9 lg:col-start-4">
            <Reveal delay={60}>
              <h2 className="g1-h2 text-[36px] md:text-[52px] lg:text-[64px] max-w-[24ch]">
                A few quiet numbers.{" "}
                <span className="g1-display-italic">
                  Offered as evidence, not as spectacle.
                </span>
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-[color:var(--g1-ink)]">
          {ANCHORS.map((a, i) => (
            <Reveal
              key={a.figure}
              delay={i * 80}
              className={`p-8 md:p-10 lg:p-12 border-b border-[color:var(--g1-rule)] ${
                i < ANCHORS.length - 1
                  ? "md:border-r md:border-[color:var(--g1-rule)]"
                  : ""
              }`}
            >
              <div
                data-testid={`anchor-figure-${i}`}
                className="font-serif text-[64px] md:text-[88px] lg:text-[112px] leading-[0.92] tracking-[-0.03em] text-[color:var(--g1-ink)]"
              >
                {a.figure}
              </div>
              <p className="font-sans text-[15px] leading-relaxed text-[color:var(--g1-ink-2)] mt-6 max-w-[28ch]">
                {a.caption}
              </p>
              <div className="g1-label mt-6 text-[color:var(--g1-ink-3)]">
                {a.source}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
